import { OthercodeGet, Ulid } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController, getIdWithCompany } from "../utils";
import { OtherCode } from "./interfaces";

export const makeOtherCode = ({ connection, company }: ApiSliceParams) => {
    const {
        items: codes,
        allLoading: loading,
        listen: listenCompany,
    } = createListController<OthercodeGet, OtherCode, string>({
        name: "othercode",
        connection,
        view: (item, company) => ({
            ...item,
            company,
            id: getIdWithCompany(item.id, company),
            _id: item.id,
        }),
        list: (con, company) => con.othercode.items({ company }),
        getId: (item, company) => getIdWithCompany(item.id, company),
        getKey: (company) => company,
    });

    const get = (
        id: string | Readonly<Ulid> | null | undefined,
        cmp = company.value,
    ) => {
        if (!id) {
            return null;
        }

        const key = getIdWithCompany(id, cmp);

        return codes.value.find((s) => s.id === key) ?? null;
    };

    const listen = () => listenCompany(company.value);

    return { codes, loading, listen, get };
};
